import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import classNames from 'classnames'
import { ListCategoryDoc } from '../../redux-toolkits/categories/categories.type'
import Icon from '../icon'

export const MiniCategoryCard = ({
  category,
  id,
  onRemove,
}: {
  category: ListCategoryDoc
  id: string
  onRemove?: () => void
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="relative flex flex-col gap-2 items-center justify-center p-2 border rounded-lg bg-frost"
    >
      <img
        src={category.icon}
        className="block w-[48px] h-[48px] aspect-square object-cover rounded-md"
        alt={`icon`}
      />

      <p className="text-sm line-clamp-1">{category.name}</p>

      <button
        className="w-fit cursor-grab mx-auto !max-w-[50px]"
        {...attributes}
        {...listeners}
        type="button"
      >
        <Icon id="rearrange" width={24} height={24} />
      </button>

      {onRemove && (
        <button
          className={classNames(
            'p-2 bg-gray-bg rounded-full w-fit absolute top-4 right-4',
          )}
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
        >
          <Icon className="text-danger" width={20} height={20} id="bin" />
        </button>
      )}
    </div>
  )
}
